import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { defineMessages } from 'react-intl';

import { postCommandFileUpdateSampleMutation } from '../api/generated-evs/@tanstack/react-query.gen';
import { createTranslatedError, ErrorTranslations } from '../errors/transtatedErrors';

const fileErrorTranslations: ErrorTranslations = defineMessages({
  'invalid-format': {
    id: 'error.invalid-format',
    defaultMessage: 'Tenhle soubor si s námi nerozumí. Přijímáme jen formáty .csv a .xlsx. Zkuste to znovu.',
  },
  'file-parse-error': {
    id: 'error.file-parse-error',
    defaultMessage: 'Chyba při zpracování souboru',
  },
  'file-empty': {
    id: 'error.file-empty',
    defaultMessage: 'Soubor je prázdný',
  },
  'banned-update-headers': {
    id: 'error.banned-update-headers',
    defaultMessage: 'V souboru jsou sloupce, které nelze upravit: {bannedUpdateHeaders}',
  },
  default: {
    id: 'error.default',
    defaultMessage: 'Něco se pokazilo. Zkuste to znovu.',
  },
});

export type FileUpdateApiCall = (file: File) => Promise<{ operationId?: string }>;

export function useFileUpdateApiCall(qreId: string): FileUpdateApiCall {
  const uploadFileUpdateSampleMutation = useMutation(postCommandFileUpdateSampleMutation());

  return useCallback(
    async (file: File) => {
      try {
        const response = await uploadFileUpdateSampleMutation.mutateAsync({
          body: {
            file,
            qreId,
          },
        });

        return response as { operationId?: string };
      } catch (error) {
        // @ts-expect-error type
        throw createTranslatedError(error, fileErrorTranslations);
      }
    },
    [uploadFileUpdateSampleMutation, qreId]
  );
}
